import { render, staticRenderFns } from "./HeatmapRegistration.vue?vue&type=template&id=185277be&scoped=true"
import script from "./HeatmapRegistration.vue?vue&type=script&lang=js"
export * from "./HeatmapRegistration.vue?vue&type=script&lang=js"
import style0 from "./HeatmapRegistration.vue?vue&type=style&index=0&id=185277be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185277be",
  null
  
)

export default component.exports